import { store } from 'createStore';

export const checkIfUnitExist = (nodeKey: string) => {
  const availableUnits = store.getState().unitConnGroup.present.unitState.units;
  const existingUnit = availableUnits.find((unit) => unit.key === nodeKey);
  if (typeof existingUnit !== 'undefined') {
    return existingUnit;
  }
};

export const checkIfUnitIsACopy = (nodeKey: string) => {
  const availableUnits = store.getState().unitConnGroup.present.unitState.units;
  const isACopy = availableUnits.find((unit) => {
    return nodeKey.includes(unit.key);
  });
  if (typeof isACopy !== 'undefined') {
    return true;
  } else {
    return false;
  }
};

export const checkIfLinkIsACopy = (linkKey: string) => {
  const availableLinks =
    store.getState().unitConnGroup.present.connectionState.connections;
  const isACopy = availableLinks.find((link) => {
    return linkKey.includes(link.key);
  });
  if (typeof isACopy !== 'undefined') {
    return true;
  } else {
    return false;
  }
};

export const findCorrectFromPortIndex = (linkKey: string) => {
  const availableLinks =
    store.getState().unitConnGroup.present.connectionState.connections;
  const availableUnitPorts =
    store.getState().unitConnGroup.present.unitState.ports;
  const currentLink = availableLinks.find((link) => {
    return linkKey.includes(link.key);
  });
  if (typeof currentLink !== 'undefined') {
    const availablePorts = availableUnitPorts[currentLink.from];
    const portIndex = availablePorts.find(
      (port) => port.key === currentLink.fromPort,
    )?.portIndex;
    if (typeof portIndex !== 'undefined') {
      return portIndex;
    }
  }
};

export const findCorrectToPortIndex = (linkKey: string) => {
  const availableLinks =
    store.getState().unitConnGroup.present.connectionState.connections;
  const availableUnitPorts =
    store.getState().unitConnGroup.present.unitState.ports;
  const currentLink = availableLinks.find((link) => {
    return linkKey.includes(link.key);
  });
  if (typeof currentLink !== 'undefined') {
    const availablePorts = availableUnitPorts[currentLink.to];
    const portIndex = availablePorts.find(
      (port) => port.key === currentLink.toPort,
    )?.portIndex;
    if (typeof portIndex !== 'undefined') {
      return portIndex;
    }
  }
};

export const checkIfLinkExist = (linkKey: string) => {
  const availableLinks =
    store.getState().unitConnGroup.present.connectionState.connections;
  const existingLink = availableLinks.find((link) => link.key === linkKey);
  if (typeof existingLink !== 'undefined') {
    return existingLink;
  }
};
